import React from 'react'
import CustomModal from 'components/global/CustomModal'
import CustomModalFooter from 'components/global/CustomModalFooter'
import { Col, Form, Input, Row } from 'antd'
import useFormSubmit from 'helper/Hooks/formSubmit'
import { AgreementPayloadType, AgreementResp } from 'types/agreement/agreement'
import { useAddAgreement, useUpdateAgreement } from 'api/Agreements/Agreeements'
import { myStore } from 'state/store'

interface AddAgreementProps {
  openModal: boolean
  setOpenModal: React.Dispatch<React.SetStateAction<boolean>>
  forApp: 'guardian' | 'mentor' | 'organizer'
  setForApp: React.Dispatch<React.SetStateAction<string | undefined>>
  selectedAgreement: AgreementResp | undefined
  setSelectedAgreement: React.Dispatch<React.SetStateAction<AgreementResp>>
}

const AddAgreement: React.FC<AddAgreementProps> = ({
  openModal,
  setOpenModal,
  forApp,
  setForApp,
  selectedAgreement,
  setSelectedAgreement,
}) => {
  const { form, handleSubmit } = useFormSubmit()
  const setModalBtnLoader = myStore(store => store.setModalBtnLoader)
  const { mutate: addAgreementMutation } = useAddAgreement()
  const { mutate: updateAgreementMutation } = useUpdateAgreement()

  const handleCloseModal = () => {
    setOpenModal(false)
  }

  const formSchema = {
    agreement: selectedAgreement ? selectedAgreement.agreement : '',
  }

  const onFinish = (values: { agreement: string }) => {
    const payload: AgreementPayloadType = {
      ...values,
      appFor: forApp,
    }
    setModalBtnLoader(true)

    if (selectedAgreement) {
      updateAgreementMutation(
        {
          payload,
          agreementId: selectedAgreement._id,
        },
        {
          onSuccess: () => {
            setSelectedAgreement(undefined)
            setModalBtnLoader(false)
            setOpenModal(false)
          },
          onError: () => {
            setModalBtnLoader(false)
          },
        },
      )
    } else {
      addAgreementMutation(payload, {
        onSuccess: () => {
          setModalBtnLoader(false)
          setForApp(undefined)
          setOpenModal(false)
        },
        onError: () => {
          setModalBtnLoader(false)
        },
      })
    }
  }

  return (
    <>
      <CustomModal
        openModal={openModal}
        closeModal={setOpenModal}
        title={'Add APP Agreement'}
        footer={
          <CustomModalFooter
            multibutton={true}
            btnAlignment="justify-center"
            btnText="Add new agreement,Save"
            closeModal={handleCloseModal}
            onSubmit={handleSubmit}
          />
        }
      >
        <Form initialValues={formSchema} form={form} onFinish={onFinish}>
          <Row gutter={24}>
            <Col>
              <label htmlFor="" className="input-label required-input">
                Agreement’s text
              </label>
              <Form.Item
                colon={false}
                name="agreement"
                rules={[
                  { required: true, message: 'Agreement text is required' },
                ]}
              >
                <Input.TextArea
                  placeholder="Enter Event Agreements"
                  required
                  name="agreement"
                  rows={16}
                />
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </CustomModal>
    </>
  )
}

export default AddAgreement
